module.exports = __webpack_public_path__ + "img/wallet_02_non_2.e110e0c7.png";